var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8187 23.32H27.4587V12.12H22.5787C22.8454 10.52 23.5387 9.13333 24.6587 7.96C25.7787 6.78666 27.2454 5.98666 29.0587 5.56V0.439998C25.0054 1.29333 21.9387 3.10666 19.8587 5.88C17.832 8.65333 16.8187 12.1733 16.8187 16.44V23.32ZM0.658694 23.32H11.2187V12.12H6.33869C6.60536 10.52 7.29869 9.13333 8.41869 7.96C9.53869 6.78666 11.0054 5.98666 12.8187 5.56V0.439998C8.81869 1.29333 5.77869 3.10666 3.69869 5.88C1.67203 8.65333 0.658694 12.1733 0.658694 16.44V23.32Z",
    fill: "#B4BBBD",
    fillOpacity: 0.71
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.6bbdb2834d7c2770d2c744560b7248a6.svg";
export { ForwardRef as ReactComponent };